import { useContext } from 'react';

import { AccordionContainer } from '@/components/AccordionContainer';
import { MonthlyPaymentRow } from '@/components/MonthlyPaymentRow';
import { DataContext } from '@/contexts/DataContext';
import useTranslation from '@/hooks/useTranslation';
import { IMonthPaymentData } from '@/types/IMonthPaymentData';
import { getObjectEntries } from '@/utils/getObjectEntries';

export const SectionPayments = () => {
  const t = useTranslation();
  const { data } = useContext(DataContext);
  const paymentsPerMonth = data?.paymentsPerMonth ?? [];

  const paymentsPerMonthPrepared: IMonthPaymentData[] = paymentsPerMonth.map((entry) => {
    const [monthName, paymentData] = getObjectEntries(entry)[0];
    return { monthName, ...paymentData };
  });

  const paymentsPerMonthPreparedIncomplete: IMonthPaymentData[] = paymentsPerMonthPrepared.filter(
    (p) => p.openAmounts.TOTAL > 0
  );

  const paymentsPerMonthPreparedComplete: IMonthPaymentData[] = paymentsPerMonthPrepared.filter(
    (p) => p.openAmounts.TOTAL === 0
  );

  return (
    <AccordionContainer keyName={'PAYMENTS'} visibleTitle={t('section.PAYMENTS')}>
      {paymentsPerMonthPreparedIncomplete.length > 0 && (
        <div style={{ marginTop: 10 }}>
          <span style={{ fontWeight: 'bold', fontSize: 12 }}>
            {t('payments.incomplete', undefined, undefined, { count: paymentsPerMonthPreparedIncomplete.length })}
          </span>
          {paymentsPerMonthPreparedIncomplete.map((data) => {
            return (
              <MonthlyPaymentRow
                key={`monthly-payment-row-${data.monthName}-${data.year}`}
                month={data.monthName}
                monthData={data}
              />
            );
          })}
        </div>
      )}
      {paymentsPerMonthPreparedComplete.length > 0 && (
        <div style={{ marginTop: 10 }}>
          <span style={{ fontWeight: 'bold', fontSize: 12 }}>
            {t('payments.complete', undefined, undefined, { count: paymentsPerMonthPreparedComplete.length })}
          </span>
          {paymentsPerMonthPreparedComplete.map((data) => {
            return (
              <MonthlyPaymentRow
                key={`monthly-payment-row-${data.monthName}-${data.year}`}
                month={data.monthName}
                monthData={data}
              />
            );
          })}
        </div>
      )}
    </AccordionContainer>
  );
};
